/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DossierAdmissionFichierDto
 */
export interface DossierAdmissionFichierDto {
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierDto
     */
    iddossierAdmissionFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierDto
     */
    iddossierAdmission?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierAdmissionFichierDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierAdmissionFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DossierAdmissionFichierDto interface.
 */
export function instanceOfDossierAdmissionFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DossierAdmissionFichierDtoFromJSON(json: any): DossierAdmissionFichierDto {
    return DossierAdmissionFichierDtoFromJSONTyped(json, false);
}

export function DossierAdmissionFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DossierAdmissionFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddossierAdmissionFichier': !exists(json, 'iddossierAdmissionFichier') ? undefined : json['iddossierAdmissionFichier'],
        'iddossierAdmission': !exists(json, 'iddossierAdmission') ? undefined : json['iddossierAdmission'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DossierAdmissionFichierDtoToJSON(value?: DossierAdmissionFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddossierAdmissionFichier': value.iddossierAdmissionFichier,
        'iddossierAdmission': value.iddossierAdmission,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

